import * as Layout from "@/components/layout/Layout";
import { lazy, Suspense } from "react";
import { Redirect, Route, Router, Switch } from "wouter";
import ErrorPage from "./components/ErrorPage";
import { PageLoading } from "./components/loading/PageLoading";
import {
  COMMAND_CENTER,
  COMMAND_CENTER_ACCOUNT_MANAGEMENT,
  COMMAND_CENTER_AUTHORIZATION,
  COMMAND_CENTER_SUPPORT,
  COMMAND_CENTER_VENDOR_MANAGEMENT,
  COMPLIANCE,
  COMPLIANCE_DASHBOARDS,
  COMPLIANCE_EXPORT,
  COMPLIANCE_HISTORY,
  COMPLIANCE_OVERVIEW,
  COMPLIANCE_MATCHES,
  COMPLIANCE_PROGRAMS,
  COMPLIANCE_SUBMISSIONS,
  COMPLIANCE_TASKS,
  COMPLIANCE_TASKS_TASK_ID,
  COMPLIANCE_TRACKING_TRACKING_ID,
  COMPLIANCE_WORKBOOKS,
  ENERGY_MANAGEMENT_BILLING_ACCOUNTS_BILLING_ACCOUNT_ID,
  ENERGY_MANAGEMENT_INITIATIVES,
  ENERGY_MANAGEMENT_INITIATIVES_INITIATIVE_ID,
  ENERGY_MANAGEMENT_INSIGHTS,
  ENERGY_MANAGEMENT_LOCATIONS,
  ENERGY_MANAGEMENT_METERS,
  ENERGY_MANAGEMENT_SERVICE_ACCOUNTS_SERVICE_ACCOUNT_ID,
  ENERGY_MANAGEMENT_STATEMENTS,
  ENERGY_MANAGEMENT_STATEMENTS_STATEMENT_ID,
  ENERGY_MANAGEMENT_UTILITIES,
  EXPLORE_DASHBOARD,
  EXPLORE_REPORTS,
  FILE_ID,
  FILE_UPLOAD,
  HOME,
  JOBS,
  JOBS_JOB_ID,
  NOTIFICATIONS,
  NOTIFICATIONS_NOTIFICATION_ID,
  PROGRAMS,
  PROGRAMS_COVERAGE_LISTS,
  PROGRAMS_OVERVIEW,
  PROGRAMS_PROGRAMS,
  PROGRAMS_PROGRAMS_NEW,
  PROGRAMS_PROGRAMS_PROGRAM_ID,
  PROGRAMS_PROGRAMS_PROGRAM_ID_COMMUNICATIONS,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CRITERIA,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_COMPLIANCE,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_ENROLLMENTS,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS_FORM_ID_EDIT,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS_FORM_ID_PREVIEW,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS_NEW,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS_NEW,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS_PORTAL_ID_EDIT,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS_PORTAL_ID_PREVIEW,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_SUBMISSIONS,
  PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_NEW,
  PROGRAMS_PROGRAMS_PROGRAM_ID_DEADLINES,
  PROGRAMS_PROGRAMS_PROGRAM_ID_EDIT,
  PROGRAMS_PROGRAMS_PROGRAM_ID_EMISSIONS,
  PROGRAMS_PROGRAMS_PROGRAM_ID_PROPERTIES,
  PROGRAMS_PROGRAMS_PROGRAM_ID_PROPERTY_MATCHES,
  PROGRAMS_PROGRAMS_PROGRAM_ID_PROPERTY_SHARE_REQUESTS,
  PROGRAMS_PUBLIC_PROGRAM_ID,
  PROGRAMS_REPORTS_CITYWIDE,
  PUBLIC_DASHBOARD_DASHBOARD_ID,
  PUBLIC_REPORT_REPORT_ID,
  SETTINGS,
  SETTINGS_TAB_NAME,
  SUPPORT,
  TitledPage,
} from "./routing";

// Import layout components
// @ts-expect-error Unsure why lazy isn't matching the expected type
const AppLayout = lazy(() => import("@/app/(main)/layout.js"));
// @ts-expect-error Unsure why lazy isn't matching the expected type
const LandingPage = lazy(() => import("@/app/page.js"));
// @ts-expect-error Unsure why lazy isn't matching the expected type
const PublicLayout = lazy(() => import("@/app/public/PublicLayout.js"));
const CommandCenterLayout = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/cc/account-management/layout.js"),
);
const StatementsLayout = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/energy-management/statements/layout.js"),
);
// @ts-expect-error Unsure why lazy isn't matching the expected type
const JobsLayout = lazy(() => import("@/app/(main)/jobs/layout.js"));
const NotificationsLayout = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/notifications/layout.js"),
);
// @ts-expect-error Unsure why lazy isn't matching the expected type
const SettingsLayout = lazy(() => import("@/app/(main)/settings/layout.js"));
const PublicDashboardLayout = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/public/dashboard/[dashboardId]/layout.js"),
);
const PublicReportsLayout = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/public/reports/[reportId]/PublicReportsLayout.js"),
);

// Import all page components
const CCAccountManagementPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/cc/account-management/page.js"),
);
const CCAuthorizationPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/cc/authorization/page.js"),
);
// @ts-expect-error Unsure why lazy isn't matching the expected type
const CCPage = lazy(() => import("@/app/(main)/cc/page.js"));
const CCVendorManagementPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/cc/vendor-management/page.js"),
);
const CCSupportPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/cc/support/page.js"),
);
const EnergyManagementDashboardsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/pages/energy-management/dashboards/DashboardsPage.js"),
);
const EnergyManagementInitiativeDetailPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/energy-management/initiatives/[initiativeId]/page.js"),
);
const EnergyManagementInitiativesPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/energy-management/initiatives/page.js"),
);
const EnergyManagementInsightsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/energy-management/insights/page.js"),
);
const LocationsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/pages/energy-management/locations/LocationsPage.js"),
);
const UtilitiesPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/pages/energy-management/utilities/UtilitiesPage.js"),
);
const MeterPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/pages/energy-management/meters/MetersPage.js"),
);
const EnergyManagementReportsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/pages/energy-management/reports/ReportsPage.js"),
);
const EnergyManagementStatementDetailPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/energy-management/statements/[statementId]/page.js"),
);
const EnergyManagementStatementsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/energy-management/statements/page.js"),
);
const EnergyManagementBillingAccountDetailPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/energy-management/billing-accounts/[billingAccountId]/page.js"),
);
const EnergyManagementServiceAccountDetailPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/energy-management/service-accounts/[serviceAccountId]/page.js"),
);
// @ts-expect-error Unsure why lazy isn't matching the expected type
const FileDetailPage = lazy(() => import("@/app/(main)/file/[id]/page.js"));
// @ts-expect-error Unsure why lazy isn't matching the expected type
const FileUploadPage = lazy(() => import("@/app/(main)/file/upload/page.js"));
// @ts-expect-error Unsure why lazy isn't matching the expected type
const HomePage = lazy(() => import("@/app/(main)/home/page.js"));
// @ts-expect-error Unsure why lazy isn't matching the expected type
const JobDetailPage = lazy(() => import("@/app/(main)/jobs/[jobId]/page.js"));
// @ts-expect-error Unsure why lazy isn't matching the expected type
const JobsPage = lazy(() => import("@/app/(main)/jobs/page.js"));
const NotificationDetailPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/notifications/[notificationId]/page.js"),
);
const NotificationsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/notifications/page.js"),
);
const ComplianceDashboardsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/compliance/dashboards/page.js"),
);
const ComplianceExportPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/compliance/export/page.js"),
);
const ComplianceHistoryPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/compliance/history/page.js"),
);
// @ts-expect-error Unsure why lazy isn't matching the expected type
const CompliancePage = lazy(() => import("@/app/(main)/compliance/page.js"));
const ComplianceProgramsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/compliance/programs/page.js"),
);
const ComplianceMatchesPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/compliance/matches/page.js"),
);
const ComplianceSubmissionsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/compliance/submissions/page.js"),
);
const ComplianceTasksPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/compliance/tasks/page.js"),
);
const ComplianceTaskDetailPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/compliance/tasks/[taskId]/page.js"),
);
const ComplianceTrackingDetailPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/compliance/tracking/[trackingId]/page.js"),
);
const ComplianceWorkbooksPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/compliance/workbooks/page.js"),
);
// @ts-expect-error Unsure why lazy isn't matching the expected type
const ProgramsPage = lazy(() => import("@/app/(main)/programs/page.js"));
const ProgramsProgramCriteriaPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/programs/programs/[programId]/criteria/page.js"),
);
const ProgramsProgramDeadlinesPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/programs/programs/[programId]/deadlines/page.js"),
);
const ProgramsProgramEmissionsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/programs/programs/[programId]/emissions/page.js"),
);
const ProgramsProgramEditPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/programs/programs/[programId]/edit/page.js"),
);
const ProgramsProgramCycleDetailPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/[cycleId]/page.js"),
);
const ProgramsProgramCycleNewPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/new/page.js"),
);
const ProgramsProgramComplianceSubpage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/[cycleId]/compliance/page.js"),
);
const ProgramsProgramEnrollmentsSubpage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/[cycleId]/enrollments/page.js"),
);
const ProgramsProgramSubmissionsSubpage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/[cycleId]/submissions/page.js"),
);
const ProgramsProgramFormsSubpage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/[cycleId]/forms/page.js"),
);
const ProgramsProgramFormsNewPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/[cycleId]/forms/new/page.js"),
);
const ProgramsProgramFormsEditPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/[cycleId]/forms/[formId]/edit/page.js"),
);
const ProgramsProgramFormsPreviewPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/[cycleId]/forms/[formId]/preview/page.js"),
);
const ProgramsProgramPortalsNewPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/[cycleId]/portals/new/page.js"),
);
const ProgramsProgramPortalsEditPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/[cycleId]/portals/[portalId]/edit/page.js"),
);
const ProgramsProgramPortalsPreviewPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/cycles/[cycleId]/portals/[portalId]/preview/page.js"),
);
const ProgramsProgramPropertiesPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/properties/page.js"),
);
const ProgramsProgramPropertyShareRequestsPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/property-share-requests/page.js"),
);
const ProgramsProgramPropertyMatchesPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/property-matches/page.js"),
);
const ProgramsProgramCommunicationsPage = lazy(
  () =>
    // @ts-expect-error Unsure why lazy isn't matching the expected type
    import("@/app/(main)/programs/programs/[programId]/communications/page.js"),
);
const ProgramsProgramDetailPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/programs/programs/[programId]/page.js"),
);
const ProgramsProgramNewPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/programs/programs/new/page.js"),
);
const ProgramsProgramsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/programs/programs/page.js"),
);
const ProgramsPublicProgramPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/programs/public/[programId]/page.js"),
);
const ProgramsCoverageListsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/programs/coverage-lists/page.js"),
);
const ProgramsReportsCitywidePage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/programs/reports/citywide/page.js"),
);
const SettingsTabPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/(main)/settings/[tabName]/page.js"),
);
// @ts-expect-error Unsure why lazy isn't matching the expected type
const SettingsPage = lazy(() => import("@/app/(main)/settings/page.js"));
// @ts-expect-error Unsure why lazy isn't matching the expected type
const SupportPage = lazy(() => import("@/app/(main)/support/page.js"));
const PublicDashboardPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/public/dashboard/[dashboardId]/page.js"),
);
const PublicReportsPage = lazy(
  // @ts-expect-error Unsure why lazy isn't matching the expected type
  () => import("@/app/public/reports/[reportId]/PublicReportsPage.js"),
);

function App() {
  return (
    <Router>
      <Switch>
        {/* Landing page - no layout */}
        <Route path="/">
          <TitledPage title="Viaduct | Energy Management & Building Performance Software">
            <Suspense fallback={<PageLoading />}>
              <LandingPage />
            </Suspense>
          </TitledPage>
        </Route>

        {/* Public routes */}
        <Route path={PUBLIC_DASHBOARD_DASHBOARD_ID}>
          {(params) => (
            <TitledPage title="Viaduct | Dashboard">
              <Suspense fallback={<PageLoading />}>
                <PublicLayout>
                  <PublicDashboardLayout>
                    <PublicDashboardPage dashboardId={params.dashboardId} />
                  </PublicDashboardLayout>
                </PublicLayout>
              </Suspense>
            </TitledPage>
          )}
        </Route>
        <Route path={PUBLIC_REPORT_REPORT_ID}>
          {(params) => (
            <TitledPage title="Viaduct | Report">
              <Suspense fallback={<PageLoading />}>
                <PublicLayout>
                  <PublicReportsLayout>
                    <PublicReportsPage reportId={params.reportId} />
                  </PublicReportsLayout>
                </PublicLayout>
              </Suspense>
            </TitledPage>
          )}
        </Route>

        {/* Main app routes with AppLayout */}
        <Route>
          <Suspense fallback={<PageLoading />}>
            <AppLayout>
              <Switch>
                <Route path={HOME}>
                  <TitledPage title="Viaduct">
                    <Suspense fallback={<PageLoading />}>
                      <HomePage />
                    </Suspense>
                  </TitledPage>
                </Route>

                <Route path={COMMAND_CENTER}>
                  <TitledPage title="Viaduct | Command Center">
                    <Suspense fallback={<PageLoading />}>
                      <CCPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMMAND_CENTER_AUTHORIZATION}>
                  <TitledPage title="Viaduct | Authorization (Command Center)">
                    <Suspense fallback={<PageLoading />}>
                      <CCAuthorizationPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMMAND_CENTER_ACCOUNT_MANAGEMENT}>
                  <TitledPage title="Viaduct | Account Management (Command Center)">
                    <Suspense fallback={<PageLoading />}>
                      <CommandCenterLayout>
                        <CCAccountManagementPage />
                      </CommandCenterLayout>
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMMAND_CENTER_VENDOR_MANAGEMENT}>
                  <TitledPage title="Viaduct | Vendor Management (Command Center)">
                    <Suspense fallback={<PageLoading />}>
                      <CCVendorManagementPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMMAND_CENTER_SUPPORT}>
                  <TitledPage title="Viaduct | Support Management (Command Center)">
                    <Suspense fallback={<PageLoading />}>
                      <CommandCenterLayout>
                        <CCSupportPage />
                      </CommandCenterLayout>
                    </Suspense>
                  </TitledPage>
                </Route>

                <Route path={SUPPORT}>
                  <TitledPage title="Viaduct | Support">
                    <Suspense fallback={<PageLoading />}>
                      <SupportPage />
                    </Suspense>
                  </TitledPage>
                </Route>

                <Route path={JOBS}>
                  <TitledPage title="Viaduct | Jobs">
                    <Suspense fallback={<PageLoading />}>
                      <JobsLayout>
                        <JobsPage />
                      </JobsLayout>
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={JOBS_JOB_ID}>
                  {(params) => (
                    <TitledPage title="Viaduct | Job">
                      <Suspense fallback={<PageLoading />}>
                        <JobsLayout>
                          <JobDetailPage jobId={params.jobId} />
                        </JobsLayout>
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>

                <Route path={FILE_UPLOAD}>
                  <TitledPage title="Viaduct | File Upload">
                    <Suspense fallback={<PageLoading />}>
                      <FileUploadPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={FILE_ID}>
                  {(params) => (
                    <TitledPage title="Viaduct | Files">
                      <Suspense fallback={<PageLoading />}>
                        <FileDetailPage id={params.id} />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>

                <Route path={NOTIFICATIONS}>
                  <TitledPage title="Viaduct | Notifications">
                    <Suspense fallback={<PageLoading />}>
                      <NotificationsLayout>
                        <NotificationsPage />
                      </NotificationsLayout>
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={NOTIFICATIONS_NOTIFICATION_ID}>
                  {(params) => (
                    <TitledPage title="Viaduct | Notification">
                      <Suspense fallback={<PageLoading />}>
                        <NotificationsLayout>
                          <NotificationDetailPage
                            notificationId={params.notificationId}
                          />
                        </NotificationsLayout>
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>

                <Route path={SETTINGS}>
                  <TitledPage title="Viaduct | Settings">
                    <Suspense fallback={<PageLoading />}>
                      <SettingsLayout>
                        <SettingsPage />
                      </SettingsLayout>
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={SETTINGS_TAB_NAME}>
                  {(params) => (
                    <TitledPage title="Viaduct | Settings">
                      <Suspense fallback={<PageLoading />}>
                        <SettingsLayout>
                          <SettingsTabPage tabName={params.tabName} />
                        </SettingsLayout>
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>

                <Route path={COMPLIANCE}>
                  <Redirect to={COMPLIANCE_OVERVIEW} />
                </Route>

                <Route path={COMPLIANCE_OVERVIEW}>
                  <TitledPage title="Viaduct | Performance Compliance">
                    <Suspense fallback={<PageLoading />}>
                      <CompliancePage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMPLIANCE_PROGRAMS}>
                  <TitledPage title="Viaduct | Programs">
                    <Suspense fallback={<PageLoading />}>
                      <ComplianceProgramsPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMPLIANCE_MATCHES}>
                  <TitledPage title="Viaduct | Program Matches">
                    <Suspense fallback={<PageLoading />}>
                      <ComplianceMatchesPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMPLIANCE_TASKS}>
                  <TitledPage title="Viaduct | Tasks">
                    <Suspense fallback={<PageLoading />}>
                      <ComplianceTasksPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMPLIANCE_TASKS_TASK_ID}>
                  {(params) => (
                    <TitledPage title="Viaduct | Task">
                      <Suspense fallback={<PageLoading />}>
                        <ComplianceTaskDetailPage taskId={params.taskId} />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={COMPLIANCE_TRACKING_TRACKING_ID}>
                  {(params) => (
                    <TitledPage title="Viaduct | Program Tracking">
                      <Suspense fallback={<PageLoading />}>
                        <ComplianceTrackingDetailPage
                          trackingId={params.trackingId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={COMPLIANCE_SUBMISSIONS}>
                  <TitledPage title="Viaduct | Submissions">
                    <Suspense fallback={<PageLoading />}>
                      <ComplianceSubmissionsPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMPLIANCE_HISTORY}>
                  <TitledPage title="Viaduct | Compliance History">
                    <Suspense fallback={<PageLoading />}>
                      <ComplianceHistoryPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMPLIANCE_WORKBOOKS}>
                  <TitledPage title="Viaduct | Workbooks">
                    <Suspense fallback={<PageLoading />}>
                      <ComplianceWorkbooksPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMPLIANCE_EXPORT}>
                  <TitledPage title="Viaduct | Export">
                    <Suspense fallback={<PageLoading />}>
                      <ComplianceExportPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={COMPLIANCE_DASHBOARDS}>
                  <TitledPage title="Viaduct | Compliance Dashboards">
                    <Suspense fallback={<PageLoading />}>
                      <ComplianceDashboardsPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={`${EXPLORE_DASHBOARD}/*?`}>
                  <TitledPage title="Viaduct | Dashboards">
                    <Suspense fallback={<PageLoading />}>
                      <EnergyManagementDashboardsPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={ENERGY_MANAGEMENT_INITIATIVES}>
                  <TitledPage title="Viaduct | Initiatives">
                    <Suspense fallback={<PageLoading />}>
                      <EnergyManagementInitiativesPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={ENERGY_MANAGEMENT_INITIATIVES_INITIATIVE_ID}>
                  {(params) => (
                    <TitledPage title="Viaduct | Initiative">
                      <Suspense fallback={<PageLoading />}>
                        <EnergyManagementInitiativeDetailPage
                          initiativeId={params.initiativeId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={`${ENERGY_MANAGEMENT_LOCATIONS}/*?`}>
                  <TitledPage title="Viaduct | Properties">
                    <Suspense fallback={<PageLoading />}>
                      <LocationsPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={`${ENERGY_MANAGEMENT_METERS}/*?`}>
                  <TitledPage title="Viaduct | Meters">
                    <Suspense fallback={<PageLoading />}>
                      <MeterPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={`${EXPLORE_REPORTS}/*?`}>
                  <TitledPage title="Viaduct | Reports">
                    <Suspense fallback={<PageLoading />}>
                      <EnergyManagementReportsPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={ENERGY_MANAGEMENT_STATEMENTS}>
                  <TitledPage title="Viaduct | Statements">
                    <Suspense fallback={<PageLoading />}>
                      <StatementsLayout>
                        <EnergyManagementStatementsPage />
                      </StatementsLayout>
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={ENERGY_MANAGEMENT_STATEMENTS_STATEMENT_ID}>
                  {(params) => (
                    <TitledPage title="Viaduct | Statement">
                      <Suspense fallback={<PageLoading />}>
                        <StatementsLayout>
                          <EnergyManagementStatementDetailPage
                            statementId={params.statementId}
                          />
                        </StatementsLayout>
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={ENERGY_MANAGEMENT_BILLING_ACCOUNTS_BILLING_ACCOUNT_ID}
                >
                  {(params) => (
                    <TitledPage title="Viaduct | Billing Account">
                      <Suspense fallback={<PageLoading />}>
                        <EnergyManagementBillingAccountDetailPage
                          billingAccountId={params.billingAccountId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={ENERGY_MANAGEMENT_SERVICE_ACCOUNTS_SERVICE_ACCOUNT_ID}
                >
                  {(params) => (
                    <TitledPage title="Viaduct | Service Account">
                      <Suspense fallback={<PageLoading />}>
                        <EnergyManagementServiceAccountDetailPage
                          serviceAccountId={params.serviceAccountId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={`${ENERGY_MANAGEMENT_UTILITIES}/*?`}>
                  <TitledPage title="Viaduct | Utilities">
                    <Suspense fallback={<PageLoading />}>
                      <UtilitiesPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={ENERGY_MANAGEMENT_INSIGHTS}>
                  <TitledPage title="Viaduct | Insights">
                    <Suspense fallback={<PageLoading />}>
                      <EnergyManagementInsightsPage />
                    </Suspense>
                  </TitledPage>
                </Route>

                <Route path={PROGRAMS}>
                  <Redirect to={PROGRAMS_OVERVIEW} />
                </Route>

                <Route path={PROGRAMS_OVERVIEW}>
                  <TitledPage title="Viaduct | Programs">
                    <Suspense fallback={<PageLoading />}>
                      <ProgramsPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={PROGRAMS_PROGRAMS}>
                  <TitledPage title="Viaduct | Programs">
                    <Suspense fallback={<PageLoading />}>
                      <ProgramsProgramsPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={PROGRAMS_PUBLIC_PROGRAM_ID}>
                  {(params) => (
                    <TitledPage title="Viaduct | Public Program">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsPublicProgramPage
                          programId={params.programId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={PROGRAMS_COVERAGE_LISTS}>
                  <TitledPage title="Viaduct | Coverage Lists">
                    <Suspense fallback={<PageLoading />}>
                      <ProgramsCoverageListsPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={PROGRAMS_PROGRAMS_NEW}>
                  <TitledPage title="Viaduct | New Program">
                    <Suspense fallback={<PageLoading />}>
                      <ProgramsProgramNewPage />
                    </Suspense>
                  </TitledPage>
                </Route>
                <Route path={PROGRAMS_PROGRAMS_PROGRAM_ID}>
                  {(params) => (
                    <TitledPage title="Viaduct | Program">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramDetailPage
                          programId={params.programId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={PROGRAMS_PROGRAMS_PROGRAM_ID_EDIT}>
                  {(params) => (
                    <TitledPage title="Viaduct | Edit Program">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramEditPage programId={params.programId} />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={PROGRAMS_PROGRAMS_PROGRAM_ID_CRITERIA}>
                  {(params) => (
                    <TitledPage title="Viaduct | Program Criteria">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramCriteriaPage
                          programId={params.programId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={PROGRAMS_PROGRAMS_PROGRAM_ID_DEADLINES}>
                  {(params) => (
                    <TitledPage title="Viaduct | Program Deadlines">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramDeadlinesPage
                          programId={params.programId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={PROGRAMS_PROGRAMS_PROGRAM_ID_EMISSIONS}>
                  {(params) => (
                    <TitledPage title="Viaduct | Program Emissions">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramEmissionsPage
                          programId={params.programId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_NEW}>
                  {(params) => (
                    <TitledPage title="Viaduct | New Program Cycle">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramCycleNewPage
                          programId={params.programId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_COMPLIANCE}
                >
                  {(params) => (
                    <TitledPage title="Viaduct | Cycle Compliance">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramComplianceSubpage
                          programId={params.programId}
                          cycleId={params.cycleId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={
                    PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_ENROLLMENTS
                  }
                >
                  {(params) => (
                    <TitledPage title="Viaduct | Cycle Enrollments">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramEnrollmentsSubpage
                          programId={params.programId}
                          cycleId={params.cycleId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={
                    PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_SUBMISSIONS
                  }
                >
                  {(params) => (
                    <TitledPage title="Viaduct | Submissions Review">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramSubmissionsSubpage
                          programId={params.programId}
                          cycleId={params.cycleId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS_NEW}
                >
                  {(params) => (
                    <TitledPage title="Viaduct | New Form">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramFormsNewPage
                          programId={params.programId}
                          cycleId={params.cycleId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={
                    PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS_FORM_ID_EDIT
                  }
                >
                  {(params) => (
                    <TitledPage title="Viaduct | Edit Form">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramFormsEditPage
                          programId={params.programId}
                          cycleId={params.cycleId}
                          formId={params.formId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={
                    PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS_FORM_ID_PREVIEW
                  }
                >
                  {(params) => (
                    <TitledPage title="Viaduct | Preview Form">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramFormsPreviewPage
                          programId={params.programId}
                          cycleId={params.cycleId}
                          formId={params.formId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={
                    PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS_NEW
                  }
                >
                  {(params) => (
                    <TitledPage title="Viaduct | New Portal">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramPortalsNewPage
                          programId={params.programId}
                          cycleId={params.cycleId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={
                    PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS_PORTAL_ID_EDIT
                  }
                >
                  {(params) => (
                    <TitledPage title="Viaduct | Edit Portal">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramPortalsEditPage
                          programId={params.programId}
                          cycleId={params.cycleId}
                          portalId={params.portalId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={
                    PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS_PORTAL_ID_PREVIEW
                  }
                >
                  {(params) => (
                    <TitledPage title="Viaduct | Preview Portal">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramPortalsPreviewPage
                          programId={params.programId}
                          cycleId={params.cycleId}
                          portalId={params.portalId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS}
                >
                  {(params) => (
                    <TitledPage title="Viaduct | Cycle Forms & Portals">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramFormsSubpage
                          programId={params.programId}
                          cycleId={params.cycleId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID}>
                  {(params) => (
                    <TitledPage title="Viaduct | Cycle Detail">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramCycleDetailPage
                          programId={params.programId}
                          cycleId={params.cycleId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={PROGRAMS_PROGRAMS_PROGRAM_ID_PROPERTIES}>
                  {(params) => (
                    <TitledPage title="Viaduct | Program Properties">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramPropertiesPage
                          programId={params.programId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route
                  path={PROGRAMS_PROGRAMS_PROGRAM_ID_PROPERTY_SHARE_REQUESTS}
                >
                  {(params) => (
                    <TitledPage title="Viaduct | Program Property Sharing">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramPropertyShareRequestsPage
                          programId={params.programId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={PROGRAMS_PROGRAMS_PROGRAM_ID_PROPERTY_MATCHES}>
                  {(params) => (
                    <TitledPage title="Viaduct | Program Property Matches">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramPropertyMatchesPage
                          programId={params.programId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={PROGRAMS_PROGRAMS_PROGRAM_ID_COMMUNICATIONS}>
                  {(params) => (
                    <TitledPage title="Viaduct | Program Communications">
                      <Suspense fallback={<PageLoading />}>
                        <ProgramsProgramCommunicationsPage
                          programId={params.programId}
                        />
                      </Suspense>
                    </TitledPage>
                  )}
                </Route>
                <Route path={PROGRAMS_REPORTS_CITYWIDE}>
                  <TitledPage title="Viaduct | Program Report (Citywide)">
                    <Suspense fallback={<PageLoading />}>
                      <ProgramsReportsCitywidePage />
                    </Suspense>
                  </TitledPage>
                </Route>

                {/* 404 fallback */}
                <Route>
                  <TitledPage title="Viaduct | Not Found">
                    <Suspense fallback={<PageLoading />}>
                      <Layout.Main withPane={false}>
                        <ErrorPage statusCode={404} />
                      </Layout.Main>
                    </Suspense>
                  </TitledPage>
                </Route>
              </Switch>
            </AppLayout>
          </Suspense>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
